import { render, staticRenderFns } from "./shiti-hengji.vue?vue&type=template&id=20ea7bd9&scoped=true&"
import script from "./shiti-hengji.vue?vue&type=script&lang=ts&"
export * from "./shiti-hengji.vue?vue&type=script&lang=ts&"
import style0 from "./shiti-hengji.vue?vue&type=style&index=0&id=20ea7bd9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea7bd9",
  null
  
)

export default component.exports